import React, { useEffect, useState } from "react";
import CreateBtn from "../../components/buttons/createBtn";
import VersionHistoryBtn, {
  AdminButton,
} from "../../components/buttons/versionHistoryBtn";
import EnableDisableModal from "../../components/modals/enableDisableModal";
import FieldForceTable from "./fieldForce";
import searcher from "../../assets/searchInput.svg";
import "./fieldForce.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const FieldForceList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";

  const filterData = {
    status: queryParamsData.get("status") ?? "",
    headquaters: queryParamsData.get("headquaters") ?? "",
    divisions: queryParamsData.get("divisions") ?? "",
  };

  const [headquater, setHeadquater] = useState(
    filterData?.headquaters.length > 0 ? filterData?.headquaters.split(",") : []
  );
  const [division, setDivisions] = useState(
    filterData?.divisions.length > 0 ? filterData?.divisions.split(",") : []
  );

  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (filterData?.headquaters.length > 0) {
      setHeadquater(
        filterData?.headquaters.length > 0
          ? filterData?.headquaters.split(",")
          : []
      );
    } else {
      setHeadquater([]);
    }
    if (filterData?.divisions.length > 0) {
      setDivisions(
        filterData?.divisions.length > 0 ? filterData?.divisions.split(",") : []
      );
    } else {
      setDivisions([]);
    }
  }, [location.search, filterData.divisions, filterData?.headquaters]);

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    { path: "/field-force/user", breadcrumb: " / field force / users" },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  const user_type = localStorage.getItem("userType");

  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Field Force" && item
      );

      setUserData(permissionValue);
    }
  }, [user_type]);

  const queryParams = [];
  if (filterData.status) queryParams.push(`status=${filterData.status}`);
  if (filterData?.headquaters.length > 0)
    queryParams.push(`headquaters=${filterData?.headquaters}`);
  if (filterData?.divisions.length > 0)
    queryParams.push(`divisions=${filterData?.divisions}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <div>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1 d-flex justify-content-between flex-column">
            <div>
              <div className="search-container d-flex justify-content-between align-items-center">
                <div className="search-box d-flex  align-items-center p-2 ms-3 m-1 mb-2">
                  <img className="styled-SVG" src={searcher} alt="o" />
                  <input
                    value={search}
                    className="search-input text-dark fw_400 px-2"
                    type="text"
                    placeholder="Search user Id, Company Employee id, employee name, etc,."
                    onChange={(e) => {
                      navigate(
                        `/field-force/user?page=1${
                          e.target.value ? `&search=${e.target.value}` : ""
                        }${queryString}`
                      );
                    }}
                  />
                </div>
                <div className=" d-flex justify-content-between m-1 mb-2">
                  <button
                    onClick={() => navigate(`/field-force/user`)}
                    className="py-1 border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
                  >
                    Clear Filters
                  </button>
                  <VersionHistoryBtn link="/field-force/user/version-history" />
                  {(user_type === "super_user" && userData?.write) ||
                  user_type === "vendor" ? (
                    <CreateBtn link="/field-force/user/create" />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <FieldForceTable
                search={search}
                setHeadquater={setHeadquater}
                headquater={headquater.length > 0 ? headquater : []}
                setDivisions={setDivisions}
                division={division}
                status={filterData?.status}
                filterData={filterData}
                page_no={page_no}
              />
            </div>
          </div>
        </div>
      </div>
      <EnableDisableModal />
    </div>
  );
};

export default FieldForceList;
